import React, { useState, useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import SearchInput from "theme/modules/Search/SearchBar/SearchInput";
import OneLineForm from "theme/components/organisms/Form/OneLineForm";
import IconButton from "theme/components/atoms/Button/IconButton";
import Skeleton from "theme/components/atoms/Skeleton/Skeleton";
import { isMobile } from "theme/helpers/deviceHelper";

const messages = defineMessages({
  search: {
    id: "modules.Search.SearchBar.SearchBarForm.search",
    defaultMessage: "Search",
  },
});

const SearchBarForm = ({
  search,
  searchTarget,
  data,
  onChange,
  onSubmit,
  onFocus,
  isExpanded,
  selected,
}) => {
  const intl = useIntl();
  const [isLoaded, setIsLoaded] = useState(false);
  const isMobileDevice = isMobile();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <OneLineForm
      appearance="button-icon"
      itemProp="potentialAction"
      itemScope
      itemType="http://schema.org/SearchAction"
      onChange={onChange}
      onSubmit={onSubmit}
      id="search-bar-form"
      input={
        <>
          <meta itemProp="target" content={searchTarget} />

          {isMobileDevice ? (
            <SearchInput
              name="search"
              id="search"
              value={search?.search}
              onFocus={onFocus}
              isExpanded={isExpanded}
              selected={selected}
            />
          ) : (
            <Skeleton isLoaded={isLoaded} width="full">
              <SearchInput
                name="search"
                id="search"
                value={search?.search}
                onFocus={onFocus}
                isExpanded={isExpanded}
                selected={selected}
              />
            </Skeleton>
          )}
        </>
      }
      button={
        <>
          <div>
            <IconButton
              appearance=""
              icon="search"
              iconType="svg"
              title={intl.formatMessage(messages.search)}
              type="submit"
              onClick={null}
            />
          </div>
        </>
      }
    />
  );
};

export default SearchBarForm;
